import { NavItem } from 'react-bootstrap'
import { NavWrapper } from './styles';

interface IProps {
    activeKey: string
}

const Tabs = (props:IProps) => {
    
    return (
        <NavWrapper bsStyle='tabs' activeKey={props.activeKey}>
            <NavItem eventKey='MATCH-OFFER' href='/manage-swaps/match-offer-deadlines'>Match Offers</NavItem>
            <NavItem eventKey='DONOR-CLEARANCE' href='/manage-swaps/donor-clearance-deadlines'>Donor Clearance</NavItem>
        </NavWrapper>
    );
}

export default Tabs;